import { datadogLogs } from '@datadog/browser-logs';

export function apiKeyLogger(message: string, messageContext?: object | undefined): void {
  datadogLogs.logger.error(message, messageContext);
}
